import { FC, useContext, useEffect } from 'react';

import { ApplicationContext } from '@src/app/contexts/Application';

import { getCalendlyUrl } from '.';

const Calendly: FC<{ onClose: Function }> = (props) => {
    const { incomings } = useContext(ApplicationContext);

    const notEmployed = incomings.some(
        (incoming: any) => incoming.employmentStatus !== 'Employed',
    );

    useEffect(() => {
        window.addEventListener('keydown', handleClose);
        return () => window.removeEventListener('keydown', handleClose);
    });

    useEffect(() => {
        const calendlyUrl = getCalendlyUrl(notEmployed);
        const calendlyEmbed = document.getElementById('calendly-embed');

        if (calendlyEmbed?.children.length === 0) {
            window.Calendly.initInlineWidget({
                url: calendlyUrl,
                parentElement: calendlyEmbed,
            });

            document.body.style.overflow = 'hidden';
        }
    }, [notEmployed]);

    const handleClose = () => {
        props.onClose();
        document.body.style.overflow = 'initial';
    };

    return (
        <div
            className='backdrop-blur-xs backdrop-filter bottom-0 fixed h-screen left-0 right-0 top-0 w-screen bg-opacity-40 bg-black'
            onClick={handleClose}
        >
            <div className='fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2'>
                <div
                    id='calendly-embed'
                    className='calendly-inline-widget'
                ></div>
                <script
                    type='text/javascript'
                    src='https://assets.calendly.com/assets/external/widget.js'
                ></script>
            </div>
        </div>
    );
};

export default Calendly;
